import { render, staticRenderFns } from "./SettlePriceListForm.vue?vue&type=template&id=38eb8098&"
import script from "./SettlePriceListForm.vue?vue&type=script&lang=js&"
export * from "./SettlePriceListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports